import { useEffect, useState } from 'react';
import './App.css';
import { Discover } from './components/Discover';
import { TopMovers } from './components/TopSignals';
import { ScreenerTable } from './components/ScreenerTable';
import { Header } from './components/Header';
import { SessionBar } from './components/SessionBar';
import { BuzzBubbles } from './components/BuzzBubbles';
import { NewsFeed } from './components/NewsFeed';
import { EconCalendar } from './components/EconCalendar';
import { Positions } from './components/Positions';
import { BitcoinSection } from './components/BitcoinSection';
import { FedSection } from './components/FedSection';
import { GoldSection } from './components/GoldSection';
import { InfoTip } from './components/InfoTip';
import { TickerChart } from './components/TickerChart';
import { PANEL_INFO } from './panelInfo';

function App() {
  const [lastUpdate, setLastUpdate] = useState<string>('');

  // Heartbeat for the header's "last update" stamp — panels fetch their own data
  useEffect(() => {
    const tick = async () => {
      try {
        const response = await fetch('/api/health');
        if (response.ok) setLastUpdate(new Date().toLocaleTimeString());
      } catch {
        /* keep previous stamp */
      }
    };
    tick();
    const interval = setInterval(tick, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="app">
      <TickerChart />
      <SessionBar />
      <Header lastUpdate={lastUpdate} />

      <div className="dashboard-container">
        {/* Left Panel: Watchlist Heatmap */}
        <div className="panel heatmap-panel">
          <div className="panel-header">
            <div className="panel-title">
              <h2>Discover</h2>
              <InfoTip paragraphs={PANEL_INFO.discover} />
            </div>
            <span className="badge">Market-wide</span>
          </div>
          <Discover />
        </div>

        {/* Center Panel: Top Movers */}
        <div className="panel signals-panel">
          <div className="panel-header">
            <div className="panel-title">
              <h2>Top Movers</h2>
              <InfoTip paragraphs={PANEL_INFO.topMovers} />
            </div>
            <span className="badge">Market-wide</span>
          </div>
          <TopMovers />
        </div>

        {/* Right Panel: Screener */}
        <div className="panel screener-panel">
          <div className="panel-header">
            <div className="panel-title">
              <h2>Screener</h2>
              <InfoTip paragraphs={PANEL_INFO.screener} />
            </div>
            <span className="badge">Market-wide</span>
          </div>
          <ScreenerTable />
        </div>
      </div>

      {/* Bitcoin: price, sentiment, leverage, context — market-wide, all viewers */}
      <BitcoinSection />

      {/* Gold: spot, range, drivers, vol, paper flow, trading clock */}
      <GoldSection />

      {/* Fed: policy rate, inflation, labor, curve, balance sheet, next FOMC */}
      <FedSection />

      {/* Positions: IBKR via local IB Gateway — renders only when configured */}
      <Positions />

      {/* News row: headlines + this week's major economic events */}
      <div className="news-row">
        <div className="panel news-section" id="news">
          <div className="panel-header">
            <div className="panel-title">
              <h2>News Wire</h2>
              <InfoTip paragraphs={PANEL_INFO.news} />
            </div>
            <span className="badge">Live headlines</span>
          </div>
          <NewsFeed />
        </div>

        <div className="panel econ-section" id="econ">
          <div className="panel-header">
            <div className="panel-title">
              <h2>Econ Calendar</h2>
              <InfoTip paragraphs={PANEL_INFO.econCalendar} />
            </div>
            <span className="badge">Majors only</span>
          </div>
          <EconCalendar />
        </div>
      </div>

      {/* Buzz Section: most talked about stocks (scroll down) */}
      <div className="panel buzz-section" id="buzz">
        <div className="panel-header">
          <h2>Most Talked About Today</h2>
          <span className="badge">Reddit · stocks only</span>
        </div>
        <BuzzBubbles />
      </div>

      <div className="footer">
        <p>Last updated: {lastUpdate || 'Never'}</p>
      </div>
    </div>
  );
}

export default App;
